// extracted by mini-css-extract-plugin
export default {"container":"_21Wpr0A","letterGroup":"_2pqauan","letterChild":"_1DkKSeD"};